<!--
 * @Author: 'lek' '2889356275@qq.com'
 * @Date: 2025-12-04 15:46:00
 * @LastEditors: 'lek' '2889356275@qq.com'
 * @LastEditTime: 2025-12-04 15:46:00
 * @FilePath: \巴斯德\公司网站\bsd_website\src\views\CorporateCulture.vue
 * @Description: 企业文化页面
-->
<template>
  <div class="app">
    <CommonHeader :headerData="headerData" @nav-change="handleNavChange" />

    <main class="main-content">
      <div class="container">
        <!-- 公司简介模块 -->
        <section class="section" v-intersection="onCompanyVisible">
          <div class="section-subtitle">{{ localizedCompanyData.subtitle }}</div>
          <h2 class="section-title">{{ localizedCompanyData.title }}</h2>
          
          <div class="company-intro">
            <div class="company-content-wrapper" :class="{ 'slide-in-left': sectionsVisible.company }">
              <!-- 左侧公司介绍 -->
              <div class="company-left">
                <div class="description-text">
                  <p v-for="(paragraph, index) in localizedCompanyData.description" :key="index">
                    {{ paragraph }}
                  </p>
                </div>
              </div>
              
              <!-- 右侧核心优势 -->
              <div class="company-right">
                <div class="core-features">
                  <h3 class="features-title">{{ $t('company.coreAdvantages') }}</h3>
                  <div class="features-list">
                    <div class="feature-item">
                      <span class="feature-marker"></span>
                      <span class="feature-text">{{ $t('company.advantages.automation') }}</span>
                    </div>
                    <div class="feature-item">
                      <span class="feature-marker"></span>
                      <span class="feature-text">{{ $t('company.advantages.aiModel') }}</span>
                    </div>
                    <div class="feature-item">
                      <span class="feature-marker"></span>
                      <span class="feature-text">{{ $t('company.advantages.pipeline') }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- 品牌故事模块 -->
        <section class="section brand-story" v-intersection="onBrandStoryVisible">
          <div class="section-subtitle">{{ localizedBrandStoryData.subtitle }}</div>
          <h2 class="section-title">{{ localizedBrandStoryData.title }}</h2>
          
          <div class="brand-story-content">
            <!-- 头部重点标题 -->
            <div class="brand-header" :class="{ 'fade-in-up': sectionsVisible.brandStory }">
              <h1 class="brand-main-title">{{ localizedBrandStoryData.mainTitle }}</h1>
            </div>
            
            <!-- 内容区域 -->
            <div class="brand-content-wrapper">
              <!-- 左侧巴斯德图像 -->
              <div class="brand-image" :class="{ 'slide-in-left': sectionsVisible.brandStory }">
                <div class="image-container">
                  <img
                    :src="brandStoryData.pasteurImage"
                    :alt="$t('company.brandStory.pasteurAlt')"
                    class="pasteur-img"
                  />
                </div>
              </div>
              
              <!-- 中间介绍文字 -->
              <div class="brand-intro" :class="{ 'fade-in-up': sectionsVisible.brandStory }">
                <!-- 荣耀内容 -->
                <div class="honor-content">
                  <div class="honor-list">
                    <div v-for="(honor, index) in localizedBrandStoryData.honors" :key="index" class="honor-item">
                      {{ honor }}
                    </div>
                  </div>
                </div>
                
                <!-- 介绍文字 -->
                <div class="intro-content">
                  <p v-for="(paragraph, index) in localizedBrandStoryData.description" :key="index">
                    {{ paragraph }}
                  </p>
                </div>
              </div>
              
              <!-- 右侧信心与热心图像 -->
              <div class="brand-confidence" :class="{ 'slide-in-right': sectionsVisible.brandStory }">
                <div class="confidence-container">
                  <img
                    :src="brandStoryData.logoImage"
                    :alt="$t('company.brandStory.confidenceAlt')"
                    class="confidence-img"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- 成就客户图片宣传 -->
        <section class="customer-achievement" ref="hero">
          <div class="achievement-image-container">
            <img
              :src="heroImage"
              :alt="$t('company.customerAchievement')"
              class="achievement-image"
              :class="{ 'fade-in': heroImageLoaded }"
              @load="onHeroImageLoad"
            />
          </div>
        </section>

      </div>
    </main>

    <CommonFooter />
    <BackToTop />
  </div>
</template>

<script>
import CommonHeader from '../components/CommonHeader.vue';
import CommonFooter from '../components/CommonFooter.vue';
import BackToTop from '../components/BackToTop.vue';

export default {
  name: 'CorporateCulture',

  components: {
    CommonHeader,
    CommonFooter,
    BackToTop
  },

  data() {
    return {
      // 头部数据配置
      headerData: {
        logo: {
          title: 'PASTEUR',
          imageUrl: require('@/assets/image/logo.png')
        },
        navigation: [
          { key: 'welcome', active: false, hovered: false },
          { key: 'company', active: true, hovered: false },
          { key: 'products', active: false, hovered: false },
          { key: 'links', active: false, hovered: false }
        ]
      },

      heroImage: require('@/../素材/成就客户.png'),

      // 组件状态管理
      sectionsVisible: {
        brandStory: false,
        company: false
      },
      
      // 首屏大图状态
      heroImageLoaded: false
    }
  },

  computed: {
    // 各模块数据配置
    heroData() {
      return {
        title: this.$t('company.title'),
        subtitle: '— COMPANY'
      }
    },

    brandStoryData() {
      return {
        subtitle: 'BRAND STORY',
        title: this.$t('company.brandStory.title'),
        mainTitle: this.$t('company.brandStory.mainTitle'),
        description: this.$t('company.brandStory.description'),
        honors: this.$t('company.brandStory.honors'),
        pasteurImage: require('@/../素材/巴斯德.png'),
        logoImage: require('@/../素材/信心与热心.png')
      }
    },

    companyData() {
      return {
        subtitle: 'ABOUT US',
        title: this.$t('company.about.title'),
        description: this.$t('company.about.description'),
        coreFeatures: [
          {
            icon: '🔬',
            title: '1st ' + this.$t('company.advantages.automation'),
            description: this.$i18n.locale === 'zh' ? '行业首创的全自动化微生物检测系统，实现无人值守操作' : 'Industry-leading fully automated microbial detection system enabling unattended operation'
          },
          {
            icon: '🤖',
            title: '1st ' + this.$t('company.advantages.aiModel'),
            description: this.$i18n.locale === 'zh' ? '基于深度学习的专业微生物识别AI模型，准确率行业领先' : 'Deep learning-based professional microbial recognition AI model with industry-leading accuracy'
          },
          {
            icon: '⚡',
            title: '1st ' + this.$t('company.advantages.pipeline'),
            description: this.$i18n.locale === 'zh' ? '完整的病原微生物检测解决方案，从样本到结果全流程自动化' : 'Complete pathogenic microbial detection solution with full automation from sample to result'
          }
        ],
        mission: this.$t('company.about.mission')
      }
    },

    // 国际化数据
    localizedCompanyData() {
      return {
        subtitle: this.$t('company.about.subtitle'),
        title: this.$t('company.about.title'),
        description: this.$t('company.about.description'),
        coreFeatures: this.$t('company.about.coreFeatures'),
        mission: this.$t('company.about.mission')
      }
    },

    localizedBrandStoryData() {
      return {
        subtitle: this.$t('company.brandStory.subtitle'),
        title: this.$t('company.brandStory.title'),
        mainTitle: this.$t('company.brandStory.mainTitle'),
        description: this.$t('company.brandStory.description'),
        honors: this.$t('company.brandStory.honors'),
        pasteurImage: require('@/../素材/巴斯德.png'),
        logoImage: require('@/../素材/信心与热心.png')
      }
    }
  },

  // 生命周期钩子
  mounted() {
    // 预加载首屏大图
    this.preloadHeroImage();
  },

  methods: {
    // 处理导航变化
    handleNavChange(index) {
      const routes = ['/welcome', '/company', '/products', '/links'];
      if (index >= 0 && index < routes.length) {
        const targetRoute = routes[index];
        if (this.$route.path !== targetRoute) {
          this.$router.push(targetRoute);
        }
      }
    },


    // 模块可见性回调函数
    onBrandStoryVisible() {
      this.sectionsVisible.brandStory = true;
    },

    onCompanyVisible() {
      this.sectionsVisible.company = true;
    },


    // 首屏大图相关方法
    preloadHeroImage() {
      const img = new Image();
      img.src = this.heroImage;
      img.onload = () => {
        this.heroImageLoaded = true;
      };
    },

    onHeroImageLoad() {
      this.heroImageLoaded = true;
    }
  },

  // 自定义指令
  directives: {
    // 元素视口检测指令
    intersection: {
      inserted(el, binding) {
        const options = {
          threshold: 0.3
        };
        
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              // 触发回调函数
              binding.value();
              observer.unobserve(el);
            }
          });
        }, options);
        
        observer.observe(el);
      }
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.app {
  font-family: 'Microsoft YaHei', sans-serif;
  background: #f8f9fa;
}

/* 响应式容器 */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 成就客户图片区样式 */
.customer-achievement {
  margin-bottom: 80px;
  padding: 60px 0;
}

.achievement-image-container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.achievement-image {
  max-width: 100%;
  height: auto;
  width: 100%;
  object-fit: contain;
  object-position: center;
  opacity: 0;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  border-radius: 16px;
  cursor: pointer;
}

.achievement-image.fade-in {
  opacity: 1;
}

.achievement-image.fade-in:hover {
  transform: scale(1.05);
  box-shadow: 0 20px 40px rgba(0, 212, 180, 0.2);
}

.main-content {
  padding: 200px 0 0 0;
}
/* 公司简介模块样式 - 与品牌故事模块一致的背景特效 */
.company-intro {
  margin-top: 60px;
  padding: 50px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 212, 180, 0.08);
  position: relative;
  overflow: hidden;
}

.company-intro::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #00D4B4, #00B8A3, #00D4B4);
  animation: gradientShift 3s ease-in-out infinite;
}

/* 内容区域 - 左右布局 */
.company-content-wrapper {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 60px;
  align-items: start;
}

.company-left {
  padding-right: 20px;
}

.company-right {
  padding-left: 20px;
}

.description-text {
  color: #4a5568;
  line-height: 1.8;
  font-size: 16px;
}

.description-text p {
  margin-bottom: 20px;
  text-align: justify;
  font-weight: 300;
}

.description-text p:last-child {
  margin-bottom: 0;
}

/* 核心优势 - 简洁设计 */
.core-features {
  padding: 35px;
  background: #f8fafb;
  border-radius: 8px;
  border-left: 3px solid #00D4B4;
  height: fit-content;
}

.features-title {
  font-size: 18px;
  color: #2d3748;
  margin-bottom: 20px;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.features-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.feature-item {
  display: flex;
  align-items: center;
  padding: 14px 0;
  border-bottom: 1px solid #e2e8f0;
  transition: all 0.3s ease;
}

.feature-item:last-child {
  border-bottom: none;
}

.feature-item:hover {
  padding-left: 8px;
  background: rgba(0, 212, 180, 0.02);
  margin: 0 -8px;
  padding-right: 8px;
  border-radius: 4px;
}

.feature-marker {
  width: 8px;
  height: 8px;
  background: #00D4B4;
  border-radius: 50%;
  margin-right: 16px;
  flex-shrink: 0;
  transition: all 0.3s ease;
}

.feature-item:hover .feature-marker {
  transform: scale(1.2);
  background: #00B8A3;
}

.feature-text {
  font-size: 15px;
  color: #4a5568;
  font-weight: 500;
  letter-spacing: 0.3px;
  transition: all 0.3s ease;
}

.feature-item:hover .feature-text {
  color: #2d3748;
}

/* 核心使命标语 - 优雅设计 */
.mission-statement {
  margin-top: 25px;
  text-align: center;
  padding: 18px 20px;
  background: linear-gradient(135deg, rgba(0, 212, 180, 0.03) 0%, rgba(0, 184, 163, 0.03) 100%);
  border: 1px solid rgba(0, 212, 180, 0.08);
  border-radius: 8px;
  position: relative;
  overflow: hidden;
  transition: all 0.3s ease;
}

.mission-statement:hover {
  background: linear-gradient(135deg, rgba(0, 212, 180, 0.06) 0%, rgba(0, 184, 163, 0.06) 100%);
  border-color: rgba(0, 212, 180, 0.12);
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(0, 212, 180, 0.08);
}

.mission-statement::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  animation: missionShine 4s ease-in-out infinite;
}

@keyframes missionShine {
  0% { left: -100%; }
  50% { left: 100%; }
  100% { left: 100%; }
}

.mission-text {
  font-size: 17px;
  font-weight: 500;
  color: #00D4B4;
  line-height: 1.4;
  letter-spacing: 0.2px;
  position: relative;
  z-index: 1;
}

/* 企业文化模块样式 - 网格布局（与核心价值观模块一致） */
.culture-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 40px;
  margin-top: 60px;
}

.culture-item {
  background: white;
  padding: 40px 30px;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.08);
  text-align: center;
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  opacity: 0;
  transform: translateY(30px);
  position: relative;
  overflow: hidden;
}

.culture-item::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #00D4B4, #00B8A3);
  transform: scaleX(0);
  transition: transform 0.3s ease;
  transform-origin: right;
}

.culture-item:hover::after {
  transform: scaleX(1);
  transform-origin: left;
}

.culture-item:hover {
  transform: translateY(-8px) scale(1.02);
  box-shadow: 0 16px 48px rgba(0, 212, 180, 0.15);
}

.culture-icon {
  width: 60px;
  height: 60px;
  margin: 0 auto 20px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  position: relative;
}

.culture-icon-image {
  width: 160px;
  height: 110px;
  transition: all 0.3s ease;
}

.culture-icon.icon-hover {
  transform: scale(1.1);
  box-shadow: 0 4px 15px rgba(0, 212, 180, 0.3);
}

.culture-icon::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: linear-gradient(45deg, transparent, rgba(255,255,255,0.2), transparent);
  transform: rotate(45deg);
  transition: all 0.3s ease;
  opacity: 0;
}

.culture-icon.icon-hover::before {
  opacity: 1;
  animation: shine 0.6s ease-in-out;
}

@keyframes shine {
  0% { transform: translateX(-100%) translateY(-100%) rotate(45deg); }
  100% { transform: translateX(100%) translateY(100%) rotate(45deg); }
}

.culture-title {
  font-size: 16px;
  color: #333;
  margin-bottom: 10px;
  font-weight: bold;
}

.culture-subtitle {
  font-size: 12px;
  color: #00D4B4;
  margin-bottom: 15px;
  text-transform: uppercase;
}

.culture-desc {
  color: #666;
  font-size: 14px;
  line-height: 1.6;
}

/* 企业精神要点列表样式 */
.spirit-points-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 20px;
}

.spirit-point-item {
  display: flex;
  align-items: center;
  padding: 16px 20px;
  background: rgba(0, 212, 180, 0.03);
  border-radius: 10px;
  border: 1px solid rgba(0, 212, 180, 0.1);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.spirit-point-item::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 3px;
  background: linear-gradient(180deg, #00D4B4, #00B894);
  transform: scaleY(0);
  transition: transform 0.3s ease;
  transform-origin: bottom;
}

.spirit-point-item:hover::before {
  transform: scaleY(1);
}

.spirit-point-item:hover {
  background: rgba(0, 212, 180, 0.06);
  border-color: rgba(0, 212, 180, 0.2);
  transform: translateX(8px);
  box-shadow: 0 4px 16px rgba(0, 212, 180, 0.1);
}

.spirit-point-text {
  font-size: 15px;
  font-weight: 500;
  color: #333;
  line-height: 1.4;
  letter-spacing: 0.3px;
  transition: all 0.3s ease;
}

.spirit-point-item:hover .spirit-point-text {
  color: #00D4B4;
}

/* 动画效果 */
@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.05); }
  100% { transform: scale(1); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}


.section {
  margin-bottom: 80px;
}

.section-title {
  font-size: 28px;
  color: #333;
  margin-bottom: 30px;
  position: relative;
  padding-left: 20px;
}

.section-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 30px;
  background: #00D4B4;
}

.section-subtitle {
  color: #00D4B4;
  font-size: 14px;
  margin-bottom: 10px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.slide-in-left {
  animation: slideInLeft 1s ease forwards;
}

.slide-in-right {
  animation: slideInRight 1s ease forwards;
}

.fade-in-up {
  animation: fadeInUp 1s ease forwards;
}

@keyframes slideInLeft {
  from { opacity: 0; transform: translateX(-50px); }
  to { opacity: 1; transform: translateX(0); }
}

@keyframes slideInRight {
  from { opacity: 0; transform: translateX(50px); }
  to { opacity: 1; transform: translateX(0); }
}

@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(30px); }
  to { opacity: 1; transform: translateY(0); }
}


.values-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 40px;
  margin-top: 60px;
}

.value-item {
  background: white;
  padding: 40px 30px;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.08);
  text-align: center;
  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
  opacity: 0;
  transform: translateY(30px);
  position: relative;
  overflow: hidden;
}

.value-item::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #00D4B4, #00B8A3);
  transform: scaleX(0);
  transition: transform 0.3s ease;
  transform-origin: right;
}

.value-item:hover::after {
  transform: scaleX(1);
  transform-origin: left;
}

.value-item:hover {
  transform: translateY(-8px) scale(1.02);
  box-shadow: 0 16px 48px rgba(0, 212, 180, 0.15);
}

.value-icon {
  width: 60px;
  height: 60px;
  margin: 0 auto 20px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  position: relative;
}

.icon-image {
  width: 160px;      
  height: 110px; 
  transition: all 0.3s ease;
}

.value-icon.icon-hover {
  transform: scale(1.1);
  box-shadow: 0 4px 15px rgba(0, 212, 180, 0.3);
}

.value-icon::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: linear-gradient(45deg, transparent, rgba(255,255,255,0.2), transparent);
  transform: rotate(45deg);
  transition: all 0.3s ease;
  opacity: 0;
}

.value-icon.icon-hover::before {
  opacity: 1;
  animation: shine 0.6s ease-in-out;
}

@keyframes shine {
  0% { transform: translateX(-100%) translateY(-100%) rotate(45deg); }
  100% { transform: translateX(100%) translateY(100%) rotate(45deg); }
}

.value-title {
  font-size: 16px;
  color: #333;
  margin-bottom: 10px;
  font-weight: bold;
}

.value-subtitle {
  font-size: 12px;
  color: #00D4B4;
  margin-bottom: 15px;
  text-transform: uppercase;
}

.value-desc {
  color: #666;
  font-size: 14px;
  line-height: 1.6;
}


/* 品牌故事模块样式 */
.brand-story {
  margin-bottom: 80px;
}

.brand-story-content {
  margin-top: 60px;
}

.brand-header {
  text-align: center;
  margin-bottom: 60px;
  opacity: 0;
  transform: translateY(30px);
}

.brand-main-title {
  font-size: 32px;
  color: #333;
  font-weight: 700;
  line-height: 1.4;
  margin: 0;
  padding: 0 20px;
  background: linear-gradient(135deg, #00D4B4 0%, #00B8A3 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-shadow: 0 2px 4px rgba(0, 212, 180, 0.1);
}

.brand-content-wrapper {
  display: grid;
  grid-template-columns: 300px 1fr 200px;
  gap: 40px;
  align-items: start;
  padding: 50px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 212, 180, 0.08);
  position: relative;
  overflow: hidden;
}

.brand-content-wrapper::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #00D4B4, #00B8A3, #00D4B4);
  animation: gradientShift 3s ease-in-out infinite;
}

/* 渐变动画效果 - 与品牌故事模块保持一致 */
@keyframes gradientShift {
  0%, 100% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
}

.brand-intro {
  opacity: 0;
  transform: translateY(30px);
  display: flex;
  flex-direction: column;
  height: 100%;
}

.intro-content {
  color: #666;
  line-height: 1.8;
  font-size: 14px;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
}

.intro-content p {
  margin-bottom: 20px;
  text-align: justify;
}

.intro-content p:last-child {
  margin-bottom: 0;
}

.brand-image {
  opacity: 0;
  transform: translateX(-50px);
}

.image-container {
  text-align: center;
  position: relative;
}

.pasteur-img {
  width: 100%;
  max-width: 280px;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.pasteur-img:hover {
  transform: scale(1.05);
}

.honor-content {
  padding: 15px;
  background: rgba(0, 212, 180, 0.05);
  border-radius: 12px;
  border: 1px solid rgba(0, 212, 180, 0.1);
  margin-bottom: 20px;
  height: fit-content;
}

.honor-list {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
}

.honor-item {
  font-size: 12px;
  color: #555;
  padding: 8px 12px;
  background: white;
  border-radius: 12px;
  text-align: center;
  transition: all 0.3s ease;
  border: 1px solid rgba(0, 212, 180, 0.15);
  font-weight: 500;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.honor-item:hover {
  background: linear-gradient(135deg, #00D4B4 0%, #00B8A3 100%);
  color: white;
  transform: translateY(-3px);
  box-shadow: 0 6px 20px rgba(0, 212, 180, 0.25);
  border-color: transparent;
}

.brand-confidence {
  opacity: 0;
  transform: translateX(50px);
}

.confidence-container {
  text-align: center;
}

.confidence-img {
  width: 100%;
  max-width: 200px;
  height: auto;
  transform: translateY(20px);
}

/* 品牌故事响应式设计 */
@media (max-width: 1024px) {
  .brand-content-wrapper {
    grid-template-columns: 1fr 250px;
    gap: 30px;
    padding: 40px;
  }
  
  .brand-confidence {
    grid-column: 1 / -1;
    justify-self: center;
    max-width: 300px;
    order: -1;
  }
  
  .brand-main-title {
    font-size: 28px;
  }
}

/* 企业文化模块响应式设计 */
@media (max-width: 1024px) {
  .culture-main-container {
    grid-template-columns: 1fr;
    gap: 40px;
    padding: 40px;
  }
  
  .culture-left-section,
  .culture-right-section {
    gap: 30px;
  }
}

@media (max-width: 768px) {
  .culture-main-container {
    padding: 30px 20px;
    gap: 30px;
  }
  
  .culture-left-section,
  .culture-right-section {
    gap: 25px;
  }
  
  .culture-mission,
  .culture-vision,
  .culture-values,
  .culture-philosophy {
    padding: 25px 20px;
  }
  
  .mission-header,
  .vision-header,
  .values-header,
  .philosophy-header {
    gap: 15px;
    margin-bottom: 15px;
  }
  
  .mission-icon,
  .vision-icon,
  .values-icon,
  .philosophy-icon {
    width: 50px;
    height: 50px;
  }
  
  .mission-icon img,
  .vision-icon img,
  .values-icon img,
  .philosophy-icon img {
    width: 25px;
    height: 25px;
  }
  
  .mission-title,
  .vision-title,
  .values-title,
  .philosophy-title {
    font-size: 18px;
  }
  
  .mission-description,
  .vision-description,
  .philosophy-description {
    font-size: 13px;
  }
  
  .values-tags {
    gap: 10px;
  }
  
  .value-tag {
    padding: 6px 12px;
    font-size: 12px;
  }
  
  .philosophy-points {
    gap: 12px;
  }
  
  .philosophy-point {
    padding: 12px;
    gap: 12px;
  }
  
  .point-number {
    min-width: 28px;
    height: 28px;
    font-size: 11px;
  }
  
  .point-text {
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .culture-main-container {
    padding: 20px 15px;
    gap: 25px;
  }
  
  .culture-left-section,
  .culture-right-section {
    gap: 20px;
  }
  
  .culture-mission,
  .culture-vision,
  .culture-values,
  .culture-philosophy {
    padding: 20px 15px;
  }
  
  .mission-header,
  .vision-header,
  .values-header,
  .philosophy-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    margin-bottom: 12px;
  }
  
  .mission-icon,
  .vision-icon,
  .values-icon,
  .philosophy-icon {
    width: 45px;
    height: 45px;
  }
  
  .mission-icon img,
  .vision-icon img,
  .values-icon img,
  .philosophy-icon img {
    width: 22px;
    height: 22px;
  }
  
  .mission-title,
  .vision-title,
  .values-title,
  .philosophy-title {
    font-size: 16px;
  }
  
  .mission-subtitle,
  .vision-subtitle,
  .values-subtitle,
  .philosophy-subtitle {
    font-size: 11px;
    margin-bottom: 6px;
  }
  
  .mission-description,
  .vision-description,
  .philosophy-description {
    font-size: 12px;
    line-height: 1.6;
  }
  
  .values-tags {
    gap: 8px;
  }
  
  .value-tag {
    padding: 5px 10px;
    font-size: 11px;
    border-radius: 15px;
  }
  
  .philosophy-points {
    gap: 10px;
  }
  
  .philosophy-point {
    padding: 10px;
    gap: 10px;
  }
  
  .point-number {
    min-width: 26px;
    height: 26px;
    font-size: 10px;
  }
  
  .point-text {
    font-size: 12px;
  }
}


</style>

/* 公司简介模块响应式设计 - 与品牌故事模块保持一致 */
@media (max-width: 1024px) {
  .company-intro {
    padding: 40px;
  }
  
  .company-content-wrapper {
    grid-template-columns: 1fr;
    gap: 40px;
  }
  
  .company-left {
    padding-right: 0;
  }
  
  .company-right {
    padding-left: 0;
  }
  
  .description-text {
    font-size: 15px;
  }
  
  .core-features {
    padding: 30px;
  }
  
  .features-title {
    font-size: 17px;
  }
  
  .feature-text {
    font-size: 14px;
  }
}

@media (max-width: 768px) {
  .company-intro {
    padding: 30px 25px;
  }
  
  .company-content-wrapper {
    grid-template-columns: 1fr;
    gap: 30px;
  }
  
  .company-left {
    padding-right: 0;
  }
  
  .company-right {
    padding-left: 0;
  }
  
  .description-text {
    font-size: 15px;
    line-height: 1.7;
  }
  
  .description-text p {
    margin-bottom: 16px;
  }
  
  .core-features {
    padding: 25px 20px;
  }
  
  .features-title {
    font-size: 16px;
    margin-bottom: 20px;
  }
  
  .features-list {
    gap: 14px;
  }
  
  .feature-item {
    padding: 14px 0;
  }
  
  .feature-marker {
    width: 6px;
    height: 6px;
    margin-right: 14px;
  }
  
  .feature-text {
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .company-intro {
    padding: 25px 20px;
  }
  
  .company-content-wrapper {
    grid-template-columns: 1fr;
    gap: 25px;
  }
  
  .company-left {
    padding-right: 0;
  }
  
  .company-right {
    padding-left: 0;
  }
  
  .description-text {
    font-size: 14px;
    line-height: 1.6;
  }
  
  .description-text p {
    margin-bottom: 14px;
  }
  
  .core-features {
    padding: 20px 15px;
  }
  
  .features-title {
    font-size: 15px;
    margin-bottom: 18px;
  }
  
  .features-list {
    gap: 12px;
  }
  
  .feature-item {
    padding: 12px 0;
  }
  
  .feature-marker {
    width: 5px;
    height: 5px;
    margin-right: 12px;
  }
  
  .feature-text {
    font-size: 13px;
  }
}